import React, { ReactElement, useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import EvoHuntMobileHeader from '../../../components/evohunt/common/ui/header/EvoHuntMobileHeader';
import EvoHuntDesktopHeader from '../../../components/evohunt/common/ui/header/EvoHuntDesktopHeader';
import useIsMobile from '../../../hooks/useIsMobile';
import { evoHuntPages } from '../../../menu';

const DashboardHeader = (): ReactElement => {
	const [isMobile, setIsMobile] = React.useState(false);

	useEffect((): (() => void) => useIsMobile(setIsMobile), []);

	const navigate = useNavigate();
	const location = useLocation();

	const [searchParams] = useSearchParams();

	const handleBack = (): void => {
		const doesAnyHistoryEntryExist: boolean = location.key !== 'default';
		if (doesAnyHistoryEntryExist) {
			if (searchParams.get('from') === 'companyTeam') {
				navigate(`../${evoHuntPages.evohunt.subMenu.companyTeamDetailPage.path}`, {
					state: { tab: 'query', idTeam: searchParams.get('idTeam') },
				});
			} else {
				navigate(-1);
			}
		} else {
			navigate('/', { replace: true });
		}
	};

	return <>{isMobile ? <EvoHuntMobileHeader handleBack={handleBack} /> : <EvoHuntDesktopHeader handleBack={handleBack} />}</>;
};

export default DashboardHeader;
